import React, {useEffect, useMemo} from "react";
import {Form} from "react-bootstrap";
import SkFieldProps from "./SkFieldProps";
import SkFieldDescriptionBlock from "./SkFieldDescriptionBlock";
import SkFieldLabel from "./SkFieldLabel";

export const buildSkoltechEmail = (first: string, last: string): string => {
  const firstClean = `${first || ""}`.trim().toLowerCase();
  const lastClean = `${last || ""}`.trim().toLowerCase();
  if (!firstClean && !lastClean) return "";

  // Ограничение длины локальной части снято (правка №3) — собираем academicfirstname.academiclastname как есть.
  const local = [firstClean, lastClean].filter(Boolean).join(".");
  if (!local) return "";

  return `${local}@skoltech.ru`;
};

/**
 * Read-only поле со сгенерированным Skoltech e-mail. Значение реактивно вычисляется из
 * ответов на Academic First Name (short_name) / Academic Last Name (short_last) и хранится
 * в Formik, чтобы отправиться как обычный ответ (бэкенд валидирует формат и длину ≤16).
 */
const SkFieldSkoltechEmail: React.FC<SkFieldProps & {
  firstNameId?: string;
  lastNameId?: string;
}> = (props) => {
  const {formikProps, firstNameId, lastNameId} = props;

  const first = firstNameId ? `${formikProps.values[firstNameId] || ""}` : "";
  const last = lastNameId ? `${formikProps.values[lastNameId] || ""}` : "";

  const email = useMemo(() => buildSkoltechEmail(first, last), [first, last]);

  // Держим вычисленное значение в Formik (только при изменении — чтобы не зациклиться).
  useEffect(() => {
    if (formikProps.values[props.name] !== email) {
      formikProps.setFieldValue(props.name, email);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  return (
    <Form.Group controlId={props.name}>
      <SkFieldLabel {...props}/>
      <Form.Control
        as={"input"}
        type={"text"}
        name={props.name}
        value={email}
        readOnly
        disabled
      />
      <SkFieldDescriptionBlock
        description={props.description}
        isInvalid={false}
        errorText={`${formikProps.errors[props.name] || ""}`}
      />
    </Form.Group>
  );
};

export default SkFieldSkoltechEmail;
